<template>
  <v-card class="mr-1" height="100%">
    <v-card-title>
      <span class="accept-terms-card-title">Termos & Condições</span>
    </v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-row align="center">
          <tooltip align="right" :disabled="termsConditionsAccepted" message="Você precisa ler os termos antes de aceitá-los">
            <v-checkbox v-model="termsConditionsAccepted" color="primary" disabled>
              <template v-slot:label>
                <span class="v-label v-label--is-disabled theme--light terms-conditions-text">
                  Li e concordo com os <span style="text-decoration: underline">termos de adesão</span>
                </span>
              </template>
            </v-checkbox>
          </tooltip>
        </v-row>
      </v-container>
      <terms-conditions-dialog id="terms-conditions" :banner="campaign.industry.acceptance.image" :markdown-text="campaign.industry.acceptance.terms">
        <v-checkbox v-model="termsConditionsAccepted" color="primary" :disabled="disabled" @change="updateAcceptance">
          <template v-slot:label>
            <span> Li e concordo com os <span style="text-decoration: underline">termos de adesão</span> </span>
          </template>
        </v-checkbox>
      </terms-conditions-dialog>
      <warning-row class="mt-4">É necessário aceitar os termos e condições antes de aceitar a campanha</warning-row>
    </v-card-text>
  </v-card>
</template>

<script>
import Tooltip from '@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip'
import WarningRow from '@/components/WarningRow.vue'

export default {
  components: {
    TermsConditionsDialog: () => import('@/modules/industria/ofertas-trade/views/components/offers-management/TermsConditionsDialog.vue'),
    Tooltip,
    WarningRow,
  },
  props: {
    campaign: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    termsAccepted: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    termsConditionsAccepted: false,
  }),
  watch: {
    termsAccepted(value) {
      this.termsConditionsAccepted = value
    },
  },
  created() {
    this.termsConditionsAccepted = this.termsAccepted
  },
  methods: {
    updateAcceptance(accepted) {
      const newValue = accepted || false
      this.$emit('acceptance-change', newValue)
    },
  },
}
</script>

<style lang="scss" scoped>
.accept-terms-card-title {
  font-size: 24px;
  font-weight: bold;
  color: $cinza-d20;
}
</style>
